import MQTTService from '../services/mqtt';
import MapService from '../../services/map';
import AggloService from '../services/Agglo';
import ItineraryService from '../services/itinerary';
import Translate from '../../services/translate';

/**
 * ------------
 * Home
 * ------------
 * @description
 * gère les évenements de la page frontpage.php
 */
export default class Home {

    constructor() {
        const mobile = !window.matchMedia("(min-width: 992px)").matches;
        const tablet = !window.matchMedia("(min-width: 1199px)").matches;
        const options = {
            id: 'mapEntete',
            style: Translate.print('map.home'),
            scrollZoom: false,
            interactive: false,
            center: [-2.5000, 46.8002],
            zoom: tablet ? 5 : 5.3,
        }

        // init
        MQTTService.initMQTT();
        if (mobile) {
            AggloService.getAllAgglos().then(function () {
                AggloService.arElements = AggloService.networksList;
                AggloService.initHomeSearchAgglo();
            });
            ItineraryService.initItinerary();
        } else {
            MapService.initMap(options).then(function () {
                AggloService.getAllAgglos().then(function () {
                    MapService.drawEvent();
                    AggloService.arElements = AggloService.networksList;
                    AggloService.initHomeSearchAgglo();
                });
                ItineraryService.initItinerary();
            });
        }
        $('[data-itinerary-coords]').attr('value', '');
        $('[data-itinerary-input]').attr('value', '');

        // listeners
        $(document).on('click', '[data-home-tab]', Home.switchTabs);
    }

    /**
     * -----------
     * switchTabs
     * -----------
     * @description
     * permet de changer de tab
     */
    static switchTabs() {
        const selectedTab = $(this).attr('data-home-tab');

        switch (selectedTab) {
            case 'network':
                $(this).removeClass('active');
                $('[data-home-itinerary]').addClass('hide');
                $('[data-home-network]').removeClass('hide');
                break;
            case 'itinerary':
                $('[data-home-tab="network"]').addClass('active');
                $('[data-home-network]').addClass('hide');
                $('[data-home-itinerary]').removeClass('hide');
                break;
        }
    }
}